class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    if (this.mainDetailsToggle.classList.contains('mega-menu')) this.setUpHover();
  }

  // Desktop mega menu opens on hover; click and keyboard still work as before.
  setUpHover() {
    // Width only: touchscreen laptops can report no hover support even with a mouse.
    this.hoverQuery = window.matchMedia('(min-width: 990px)');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.addEventListener('pointerenter', (event) => {
      if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
      clearTimeout(this.hoverCloseTimer);
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this && menu.mainDetailsToggle.open) menu.close();
      });
      if (!this.mainDetailsToggle.open) {
        this.openedByHover = true;
        this.mainDetailsToggle.setAttribute('open', '');
        this.summary.setAttribute('aria-expanded', true);
      }
    });

    this.addEventListener('pointerleave', (event) => {
      if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = setTimeout(() => {
        this.openedByHover = false;
        this.close();
      }, 200);
    });

    // A click on a menu item that hover already opened keeps the panel open.
    this.summary.addEventListener('click', (event) => {
      if (this.hoverQuery.matches && this.openedByHover && this.mainDetailsToggle.open) {
        event.preventDefault();
        this.openedByHover = false;
      }
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
